import { apiClient } from '../util/http';

/**
 * Records a metric event in the backend for analytics or monitoring.
 *
 * Intended for logging user actions or system events such as downloads,
 * report generations, or errors.
 *
 * @async
 * @function createMetric
 * @param {Object} payload - Metric creation parameters.
 * @param {string} payload.key - Unique identifier of the metric (e.g. "payroll.payment-statement-report").
 * @param {string} payload.source - Source or component where the metric originated (e.g. "payroll.details.download-button").
 * @param {Object} [payload.details] - Optional structured context (e.g. `{ userId: 42, durationMs: 1200 }`).
 * @returns {Promise<any>} The backend response data.
 *
 * @example
 * await createMetric({
 *   key: 'payroll.payment-statement-report',
 *   source: 'payroll.details.download-button',
 *   details: { userId: 123, status: 'success' },
 * });
 */
export async function createMetric(payload) {
  try {
    const response = await apiClient.post('/metric', payload);
    return response.data;
  } catch (error) {
    // Não deve bloquear nenhuma operação caso ocorra algum erro ao enviar a métrica
    console.error('[Metric] Failed to send metric:', error?.message || error);
  }

  return null;
}
